// services/globalTaskCalendarService.js
import { api } from './api';
import { objectToQueryString } from '../utils/apiUtils';

/**
 * Service for Global Task Calendar operations
 * Follows the same pattern as other services in the codebase
 */

// Get tasks grouped by date for calendar view
export const getGlobalCalendarTasks = async (params = {}) => {
  const queryString = objectToQueryString(params);
  return api.get(`/global-task-calendar/tasks${queryString}`);
};

// Get lightweight summary (counts only) for calendar
export const getGlobalCalendarSummary = async (params = {}) => {
  const queryString = objectToQueryString(params);
  return api.get(`/global-task-calendar/summary${queryString}`);
};

// Get detailed tasks for a specific day
export const getGlobalCalendarDayTasks = async (date, params = {}) => {
  const queryString = objectToQueryString(params);
  return api.get(`/global-task-calendar/day/${date}${queryString}`);
};

// Export all methods as default for consistency
export default {
  getGlobalCalendarTasks,
  getGlobalCalendarSummary,
  getGlobalCalendarDayTasks
};